var _style, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _line63, _line64, _line65, _line66, _polyline, _line67, _polyline2, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _polyline3, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _polyline4, _polyline5, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _polyline6, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _polyline7, _line135, _line136, _polyline8, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _polyline9, _polyline10, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _polyline11, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _polyline12, _line165, _polyline13, _line166, _polyline14, _line167, _line168, _line169, _line170, _line171, _line172, _line173, _line174, _line175, _line176, _line177, _line178, _line179, _polyline15, _polyline16, _polyline17, _line180, _line181, _line182, _line183, _polyline18, _text19, _text20, _text21, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24, _polyline25, _polyline26, _polyline27, _polyline28, _polyline29, _polyline30, _polyline31, _polyline32, _polyline33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPavilionBigRasterEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1017.7px",
    height: "800.7px",
    viewBox: "0 0 1017.7 800.7",
    style: {
      enableBackground: "new 0 0 1017.7 800.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.196;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#EF3E23;stroke-width:0.49;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{font-family:'AAHA-WEB';}\n\t.st3{font-size:11.76px;}\n\t.st4{font-size:11.8188px;}\n\t.st5{letter-spacing:23;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 255.3,
    y1: 474.6,
    x2: 253.1,
    y2: 473
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 273,
    y1: 434.6,
    x2: 249,
    y2: 412.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247,
    y1: 412.3,
    x2: 246.6,
    y2: 411.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 410.7,
    x2: 246.6,
    y2: 411.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.2,
    y1: 436.5,
    x2: 247,
    y2: 414.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247,
    y1: 412.3,
    x2: 247,
    y2: 414.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.2,
    y1: 436.5,
    x2: 273,
    y2: 436.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247,
    y1: 414.3,
    x2: 249,
    y2: 414.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 273,
    y1: 436.4,
    x2: 273,
    y2: 434.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 273,
    y1: 436.4,
    x2: 249,
    y2: 414.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249,
    y1: 414.2,
    x2: 249,
    y2: 412.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 270.5,
    y1: 432,
    x2: 249.3,
    y2: 412.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 270.5,
    y1: 432.3,
    x2: 270.5,
    y2: 432
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 273.2,
    y1: 505.3,
    x2: 272.4,
    y2: 503.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.2,
    y1: 505.7,
    x2: 268.4,
    y2: 503.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.2,
    y1: 505.7,
    x2: 273.2,
    y2: 505.3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 267.5,
    y1: 502.6,
    x2: 272.6,
    y2: 502.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 268.4,
    y1: 503.2,
    x2: 273.5,
    y2: 503.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.7,
    y1: 502.5,
    x2: 254.2,
    y2: 471.7
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.4,
    y1: 505.8,
    x2: 272.2,
    y2: 505.7
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.7,
    y1: 502.5,
    x2: 266.9,
    y2: 502.6
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.6,
    y1: 502.5,
    x2: 273.7,
    y2: 502.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 268.4,
    y1: 503.2,
    x2: 267.5,
    y2: 502.6
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.6,
    y1: 502.5,
    x2: 273.5,
    y2: 503.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.2,
    y1: 505.7,
    x2: 272.2,
    y2: 505.7
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 273.2,
    y1: 505.3,
    x2: 270.1,
    y2: 503.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.9,
    y1: 502.6,
    x2: 267.5,
    y2: 502.6
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.3,
    y1: 472.6,
    x2: 255,
    y2: 473.8
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 250,
    y1: 469.2,
    x2: 252.5,
    y2: 471
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 249,
    y2: 469.6
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.4,
    y1: 472.4,
    x2: 248.9,
    y2: 469.9
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 270.3,
    y1: 467.1,
    x2: 270.3,
    y2: 467.4
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.1,
    y1: 467.2,
    x2: 269.2,
    y2: 467.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 270.3,
    y1: 467.4,
    x2: 269.2,
    y2: 467.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 270.3,
    y1: 467.1,
    x2: 270.3,
    y2: 467
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249,
    y1: 469.6,
    x2: 249,
    y2: 469.3
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249,
    y1: 469.6,
    x2: 248.9,
    y2: 469.9
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 252.4,
    y2: 472.4
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 471.8,
    x2: 253.1,
    y2: 472.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.1,
    y1: 472.2,
    x2: 253.2,
    y2: 472.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.3,
    y1: 472.6,
    x2: 253.1,
    y2: 472.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 255.1,
    y2: 474
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 254.2,
    y1: 471.7,
    x2: 252.5,
    y2: 471.8
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.3,
    y1: 469.5,
    x2: 247.4,
    y2: 469.6
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.2,
    y1: 472.5,
    x2: 254.5,
    y2: 472.4
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.9,
    y1: 469.9,
    x2: 247.4,
    y2: 469.6
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 251.3,
    y1: 472.4,
    x2: 247.4,
    y2: 469.6
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 251.3,
    y1: 472.4,
    x2: 252.4,
    y2: 472.4
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.4,
    y1: 473.2,
    x2: 251.3,
    y2: 472.4
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.6,
    y1: 473.1,
    x2: 252.6,
    y2: 473.1
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 468.1,
    x2: 245.3,
    y2: 467.3
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 254.5,
    y1: 472.6,
    x2: 253.3,
    y2: 472.6
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 255.3,
    y1: 474.5,
    x2: 252.4,
    y2: 472.4
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 254.4,
    y1: 472.2,
    x2: 253.1,
    y2: 472.2
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.1,
    y1: 467.1,
    x2: 269.1,
    y2: 467.2
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 268.5,
    y1: 464.8,
    x2: 268.5,
    y2: 466.1
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.5,
    y1: 467.1,
    x2: 268.5,
    y2: 466.1
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 252.5,
    y2: 471
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 268.5,
    y1: 464.8,
    x2: 245.3,
    y2: 467.3
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.4,
    y1: 469.5,
    x2: 245.6,
    y2: 468.7
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 268.5,
    y1: 466.1,
    x2: 245.5,
    y2: 468.6
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.5,
    y1: 467.1,
    x2: 247.4,
    y2: 469.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 53.0627 646.0122)",
    className: "st2 st3"
  }, "CAMPAIGN CALENDAR")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 31.7727 460.041)",
    className: "st2 st3"
  }, "UNDER STAIR STORAGE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.995 0 0 1 844.8892 205.9058)",
    className: "st2 st4"
  }, "BANNERS FOR FUGITIVES")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 844.8882 316.1504)",
    className: "st2 st3"
  }, "STOP THE SWEEPS HOARDING")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 51.9652 508.8853)",
    className: "st2 st3"
  }, "CAMPAIGN STORAGE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4.4839 547.4995)",
    className: "st2 st3 st5"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 60.5839 547.4995)",
    className: "st2 st3 st5"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 116.6838 547.4995)",
    className: "st2 st3 st5"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 144.7839 547.4995)",
    className: "st2 st3"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 150.1198 541.498)",
    className: "st2 st3"
  }, "FILM")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4.4843 552.9414)",
    className: "st2 st3"
  }, "ATLAS OF HOUSING ALIENATION")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 844.8889 261.0889)",
    className: "st2 st3"
  }, "COMMUNAL WORK DESK")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 844.8882 371.2109)",
    className: "st2 st3"
  }, "CAMPAIGN MAP")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 845.8882 515.2148)",
    className: "st2 st3"
  }, "LAND BACK COURTYARD")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 842.8882 591.1602)",
    className: "st2 st3"
  }, "OPEN WOOD PIN-UP WALLS")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 852.6611 602.6016)",
    className: "st2 st3"
  }, "WITH NINE PROJCTS")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 845.8884 671.5483)",
    className: "st2 st3"
  }, "TWO LARGE WORKTABLES")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 843.8889 730.6084)",
    className: "st2 st3"
  }, "TEN DEMAND BANNERS")), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.8,
    y1: 466.9,
    x2: 246.6,
    y2: 465.3
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.1,
    y1: 524.4,
    x2: 267,
    y2: 524.8
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.1,
    y1: 524.4,
    x2: 265.3,
    y2: 524.1
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 265.3,
    y1: 524.1,
    x2: 266.5,
    y2: 525.4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "270,529.4 268.9,528 267.7,526.7 266.5,525.4 "
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.4,
    y1: 474,
    x2: 242.2,
    y2: 471.4
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.7,470 238.2,469.9 239.7,469.9 241.1,469.9 242.6,469.9 244.1,469.9 245.6,469.8 "
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 265.3,
    y1: 524.1,
    x2: 265,
    y2: 524.4
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.8,
    y1: 524.7,
    x2: 264.4,
    y2: 525
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 464.6,
    x2: 244.3,
    y2: 465.1
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 465.9,
    x2: 235.7,
    y2: 465.9
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 265.1,
    y1: 528.4,
    x2: 243.5,
    y2: 475.3
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.2,
    y1: 473.2,
    x2: 249.3,
    y2: 471.1
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.3,
    y1: 471.1,
    x2: 249.7,
    y2: 472.1
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.2,
    y1: 527.8,
    x2: 266.5,
    y2: 525.4
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.3,
    y1: 525,
    x2: 264.4,
    y2: 525
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 265.1,
    y1: 524.5,
    x2: 242.9,
    y2: 470.1
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 265.1,
    y1: 524.5,
    x2: 264,
    y2: 525
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 241.8,
    y1: 470.3,
    x2: 264,
    y2: 525
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.7,470 236.7,468.6 236.7,467.2 "
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.3,
    y1: 470.9,
    x2: 265,
    y2: 524.3
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.6,
    y1: 474.8,
    x2: 246.5,
    y2: 474.8
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.1,
    y1: 466.6,
    x2: 249.2,
    y2: 466.9
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.1,
    y1: 466.6,
    x2: 249.5,
    y2: 466.9
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.4,
    y1: 474.7,
    x2: 243.5,
    y2: 475.2
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 465.3,
    x2: 246.6,
    y2: 465.3
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.5,
    y1: 473.2,
    x2: 249.7,
    y2: 472.1
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.1,
    y1: 466.6,
    x2: 248.6,
    y2: 466.8
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 471,
    x2: 244.7,
    y2: 466.7
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "244.7,466.7 245.2,468.3 245.6,469.8 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "265.6,530.9 265.2,529 264.8,527 264.4,525 "
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 465.3,
    x2: 247.3,
    y2: 467.1
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 474.2,
    x2: 265.7,
    y2: 524.3
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 474.2,
    x2: 249.3,
    y2: 474.3
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 237.3,
    y1: 474.6,
    x2: 243.6,
    y2: 474.7
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.6,
    y1: 525.8,
    x2: 264.2,
    y2: 525
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.7,
    y1: 475.1,
    x2: 246.5,
    y2: 474.8
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.8,
    y1: 524.7,
    x2: 246.5,
    y2: 474.8
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.8,
    y1: 473.9,
    x2: 248.5,
    y2: 470.5
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.3,
    y1: 467.1,
    x2: 246.6,
    y2: 465.3
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.4,
    y1: 525,
    x2: 264.4,
    y2: 525
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 242.6,
    y1: 469.9,
    x2: 241.8,
    y2: 470.3
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.7,
    y1: 467.3,
    x2: 244.8,
    y2: 465
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "270,529.4 271.2,530.7 272.4,532 "
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 250.3,
    y1: 473.8,
    x2: 249.7,
    y2: 472.1
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.4,
    y1: 532,
    x2: 273.6,
    y2: 533.4
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 239,
    y1: 477.5,
    x2: 247.5,
    y2: 485.3
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.5,
    y1: 475.3,
    x2: 243.5,
    y2: 475.2
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 238.2,
    y2: 465.7
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 465.4,
    x2: 236.6,
    y2: 471.3
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 236.7,
    y2: 465.4
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 236.7,
    y2: 465.8
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.5,
    y1: 472.7,
    x2: 236.7,
    y2: 465.4
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.4,
    y1: 525.1,
    x2: 264.2,
    y2: 525
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.2,
    y1: 525,
    x2: 264.2,
    y2: 524.9
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.9,
    y1: 527.8,
    x2: 243.5,
    y2: 475.2
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.3,
    y1: 470.9,
    x2: 245.6,
    y2: 469.8
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.6,
    y1: 530.5,
    x2: 272.4,
    y2: 532
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 267,
    y1: 524.8,
    x2: 267.8,
    y2: 525.1
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.2,
    y1: 527.8,
    x2: 270,
    y2: 529.4
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 269.2,
    y1: 527.8,
    x2: 267,
    y2: 524.8
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.1,
    y1: 524.4,
    x2: 266.5,
    y2: 525.4
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 468.6,
    x2: 238.2,
    y2: 469.9
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 239.2,
    y1: 468.6,
    x2: 236.7,
    y2: 467.2
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 469.1,
    x2: 247.5,
    y2: 472.1
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.2,
    y1: 529.6,
    x2: 271,
    y2: 528.3
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.2,
    y1: 525,
    x2: 264,
    y2: 525
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.2,
    y1: 529.6,
    x2: 267.8,
    y2: 525.1
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.2,
    y1: 529.6,
    x2: 267,
    y2: 524.8
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 271.2,
    y1: 529.6,
    x2: 269.2,
    y2: 527.8
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 465.7,
    x2: 235.7,
    y2: 465.8
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 235.7,
    y1: 465.9,
    x2: 235.9,
    y2: 475.5
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 464.6,
    x2: 245.7,
    y2: 464.6
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.5,
    y1: 475.2,
    x2: 235.9,
    y2: 475.5
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 235.9,
    y1: 475.5,
    x2: 235.9,
    y2: 475.6
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.2,
    y1: 473.3,
    x2: 252.9,
    y2: 473.1
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.5,
    y1: 474,
    x2: 252.9,
    y2: 473.1
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 474.8,
    x2: 248.5,
    y2: 474.3
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "243.5,475.3 243.5,475.3 235.9,475.6 "
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 237.3,
    y1: 474.6,
    x2: 236.4,
    y2: 474
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 465.3,
    x2: 245.7,
    y2: 464.6
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "265.6,530.9 266,532.9 266.3,534.9 266.7,536.8 "
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.7,
    y1: 466.7,
    x2: 244.3,
    y2: 465.1
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.8,
    y1: 465,
    x2: 244.3,
    y2: 465.1
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.5,
    y1: 472.1,
    x2: 246.3,
    y2: 469
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 471,
    x2: 245.6,
    y2: 469.8
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 471,
    x2: 247.5,
    y2: 472.1
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 464.8,
    x2: 244.8,
    y2: 465
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 464.8,
    x2: 246,
    y2: 467.2
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 464.8,
    x2: 245.7,
    y2: 464.6
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.4,
    y1: 473.2,
    x2: 247.5,
    y2: 472.1
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.4,
    y1: 473.2,
    x2: 249.3,
    y2: 474.3
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "244.3,465.1 242.8,465.3 241.3,465.4 239.7,465.5 238.2,465.7 236.7,465.8 "
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.6,464.6 236.6,465 236.7,465.4 236.7,465.8 "
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 240.8,
    y1: 467.7,
    x2: 238.2,
    y2: 465.7
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 240.8,
    y1: 467.7,
    x2: 245.2,
    y2: 468.3
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 242.8,
    y1: 465.3,
    x2: 240.8,
    y2: 467.7
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.7,
    y1: 466.7,
    x2: 240.8,
    y2: 467.7
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.7,
    y1: 466.7,
    x2: 242.8,
    y2: 465.3
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 239.2,
    y1: 468.6,
    x2: 240.8,
    y2: 467.7
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 241.7,
    y1: 468.8,
    x2: 244.1,
    y2: 469.9
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 241.7,
    y1: 468.8,
    x2: 245.2,
    y2: 468.3
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 241.1,
    y1: 469.9,
    x2: 239.2,
    y2: 468.6
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "273.3,550 272.3,548.6 271.3,547.2 270.4,545.7 "
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 471.3,
    x2: 236.7,
    y2: 470
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 236.6,
    y2: 471.3
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.5,
    y1: 472.7,
    x2: 236.6,
    y2: 471.3
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.5,
    y1: 472.7,
    x2: 236.4,
    y2: 474
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 266.7,
    y1: 536.8,
    x2: 270.4,
    y2: 545.7
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.4,
    y1: 474,
    x2: 243.3,
    y2: 474.1
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 265.1,
    y1: 524.5,
    x2: 265,
    y2: 524.6
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.4,
    y1: 525,
    x2: 264.3,
    y2: 525
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.3,
    y1: 524.9,
    x2: 264.3,
    y2: 525
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.4,474 236.5,472.1 236.5,470.2 236.5,468.4 236.6,466.5 236.6,464.6 "
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.7,
    y1: 472.1,
    x2: 251.5,
    y2: 473.4
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "246.7,467.2 246.3,466.3 245.7,464.6 "
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.4,
    y1: 471.1,
    x2: 249.3,
    y2: 471.1
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "249.3,474.3 248.7,472.7 248.1,471.1 247.7,469.8 "
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 264.3,
    y1: 524.9,
    x2: 264.3,
    y2: 525
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 235.7,
    y1: 465.9,
    x2: 235.7,
    y2: 465.8
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 534.2,
    y1: 775.9,
    x2: 534.7,
    y2: 772.1
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 526.8,
    y1: 772.7,
    x2: 527.4,
    y2: 774.4
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 528.9,
    y1: 774,
    x2: 527.4,
    y2: 774.4
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 532.5,
    y1: 774.7,
    x2: 526.4,
    y2: 775.3
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 526.4,
    y1: 775.3,
    x2: 528.9,
    y2: 774
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 528.9,
    y1: 774,
    x2: 531.5,
    y2: 774.2
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 528.9,
    y1: 774,
    x2: 530.5,
    y2: 773.6
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 534.5,
    y1: 777.5,
    x2: 534.5,
    y2: 777.6
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 534.4,
    y1: 776.4,
    x2: 534.5,
    y2: 777.5
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 534.4,
    y1: 776.5,
    x2: 534.5,
    y2: 777.6
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 534.4,
    y1: 776.5,
    x2: 534.4,
    y2: 776.4
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "528,776.4 529.9,776 531.7,775.6 533.6,775.2 "
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "524.3,777.2 525.3,776.3 526.4,775.3 527.4,774.4 "
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "524.8,779.9 534.4,777.5 534.5,777.5 "
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 528,
    y1: 776.4,
    x2: 524.3,
    y2: 777.2
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 524.7,
    y1: 780.1,
    x2: 534.5,
    y2: 777.6
  })), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 533.6,
    y1: 775.2,
    x2: 533.5,
    y2: 775
  })), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 524.8,
    y1: 779.9,
    x2: 524.7,
    y2: 780.1
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "530.5,773.6 531.5,774.2 532.5,774.7 533.6,775.2 "
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 7.0941 694.1426)",
    className: "st2 st3"
  }, "MOVEABLE BENCHES")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 8.0669 752.6831)",
    className: "st2 st3"
  }, "BUILT-IN BENCHES")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 844.8882 436.269)",
    className: "st2 st3"
  }, "BUILT-IN DESK WITH LAPTOP")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1136,
    height: 1580,
    xlinkHref: "/img/pavilion.png",
    transform: "matrix(0.48 0 0 0.48 235.2 22.14)"
  }), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "599.9,647.8 794.4,594.8 839.1,594.8 "
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "297.8,560.6 202.9,543.2 180.9,543.2 "
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "351.8,165.9 195.6,456 154.3,456 "
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "583.2,314.5 797.4,311.7 839.1,311.7 "
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "272.7,485.8 202.9,505.1 160.1,505.1 "
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "343.4,637.5 202.9,690.2 113.6,690.2 "
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "645.3,490.9 794.4,367.6 839.1,367.6 "
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "533.7,544.6 794.4,511.2 839.1,511.2 "
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "612.9,689.3 794.4,667 839.1,667 "
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "532.6,754.5 793.3,726.8 838,726.8 "
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "607.4,212.2 790.2,256.6 839.1,256.6 "
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "713.4,157.4 790.2,201.7 839.1,201.7 "
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "493.4,615 202.9,748.8 113.6,748.8 "
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "398.8,569.9 202.9,642.1 169.6,642.1 "
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "658.2,497.1 794.4,432.5 839.1,432.5 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPavilionBigRasterEn);
export default __webpack_public_path__ + "static/media/pavilionBigRaster_en.bc9c63188ab33d38fc16c5bf07c6a053.svg";
export { ForwardRef as ReactComponent };